import { AppSettings } from '../AppSettings';
import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class AuthenticationService {
  constructor(private http: Http) { }

  login(username: string, password: string) {
    var headers = new Headers();
    //this.createAuthorizationHeader(headers);
    headers.append('Content-Type', 'application/json');
    return this.http.post(AppSettings.SERVICE_ENDPOINT + '/api/authenticate', JSON.stringify({ username: username, password: password }), {
      headers: headers
    }).map((response: Response) => {
      // login successful if there's a jwt token in the response
      let user = response.json();
      if (user && user.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('currentUser', JSON.stringify(user));
      }
    });
  }

  createAuthorizationHeader(headers: Headers) {
    headers.append('Authorization', 'Basic ' +
      btoa('a20e6aca-ee83-44bc-8033-b41f3078c2b6:c199f9c8-0548-4be79655-7ef7d7bf9d20'));
  }

  logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
  }
}


// WEBPACK FOOTER //
// ./src/app/login/authentication.service.ts